const { resolveLanguagePopupGate } = require('./language-popup-gate');

const LANGUAGE_POPUP_PENDING_KEY = 'decolegnoLanguagePopupPending';

function readLanguagePopupPending() {
    try {
        return sessionStorage.getItem(LANGUAGE_POPUP_PENDING_KEY) === '1';
    } catch {
        return false;
    }
}

function writeLanguagePopupPending(pending) {
    try {
        if (pending) {
            sessionStorage.setItem(LANGUAGE_POPUP_PENDING_KEY, '1');
            return;
        }

        sessionStorage.removeItem(LANGUAGE_POPUP_PENDING_KEY);
    } catch {
        // Session storage is unavailable in some private-browsing modes.
    }
}

function showPopupIfNeeded(data) {
    const current_url = window.location.href;
    if (typeof data.expected_site === 'undefined' || data.expected_site === null) {
        return;
    }

    const expectedSite = data.expected_site;
    const otherSite = data.other_site;

    if (current_url.startsWith(expectedSite.domain)) {
        return;
    }

    const modalScreen = document.querySelector('.js-language-modal');
    const documentBody = document.body;

    const goToButton = document.getElementById('js-go-to-btn');
    const goToButtonText = document.getElementById('js-go-to-btn-text');

    const stayButton = document.getElementById('js-stay-on-btn');
    const stayButtonText = document.getElementById('js-stay-on-btn-text');

    goToButton.setAttribute('href', expectedSite.move_to_site_url)
    goToButton.setAttribute('onclick', "dataLayer.push({'event': 'popup_site_switcher_click', 'category': 'popup', 'label': '" + expectedSite.gtm_event_label_move_to + "'})")
    goToButtonText.innerHTML = "Ga naar " + expectedSite.domain.replace('https://', '')

    stayButton.setAttribute('onclick', "dataLayer.push({'event': 'popup_site_switcher_click', 'category': 'popup', 'label': '" + otherSite.gtm_event_label_stay_on + "'})")
    stayButton.addEventListener('click', function(event) {
        event.preventDefault();
        modalScreen.classList.remove('open');
        documentBody.classList.remove('no-scroll');
    })
    stayButtonText.innerHTML = "Blijf op " + otherSite.domain.replace('https://', '')

    modalScreen.classList.add('open')
    documentBody.classList.add('no-scroll')
}


function checkRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const decision = resolveLanguagePopupGate({
        disabled: Boolean(window.languagePopup && window.languagePopup.disabled === '1'),
        flagSwitch: urlParams.get('flag_switch') === '1',
        currentUrl: window.location.href,
        referrer: document.referrer,
        pending: readLanguagePopupPending(),
    });

    writeLanguagePopupPending(decision.pending);

    if (decision.action !== 'show') {
        return;
    }

    if (!window['fetch']) {
        writeLanguagePopupPending(true);
        return;
    }

    fetch('/wp-json/redirect/v1/get_user_info')
        .then((data) => data.json())
        .then((json) => showPopupIfNeeded(json))
        .catch(() => writeLanguagePopupPending(true));
}

checkRedirect();
